import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/app/error.tsx");
